import React, { useContext } from "react";
import { MdSchool } from "react-icons/md";

import {AuthContext} from '../services/Session/Context'

const OrganisationCard = () => {
  const { user: { organisation } } = useContext(AuthContext)

  return (
    <form className="shadow-md">
      <div className="p-4 bg-blue-300 border-t-2 border-blue-400 bg-opacity-5">
        <div className="max-w-sm mx-auto md:w-full md:mx-0">
          <div className="inline-flex items-center space-x-4">
            <MdSchool className="bg-blue-500 rounded-full h-10 w-10 p-2" color="white" />
              <h1 className="text-slate-600 font-bold uppercase">
                Mon organisation
              </h1>
          </div>
        </div>
      </div>
      <div className="space-y-6 bg-white">
        <div className="text-gray-500 flex-col flex items-center w-full py-5">
          <h2 className="mt-2 mb-2 w-full text-center font-bold">
              { organisation.name }
          </h2>
          <small>SIRET: { organisation.siret}</small>
          <small>N° NDA: { organisation.nda}</small>
          <span className="px-2 py-1 mt-5 flex items-center font-semibold text-xs rounded-md text-yellow-700 bg-yellow-50 uppercase">
            Offre {organisation.offer}
          </span>
        </div>
      </div>
    </form>
  );
}

export default OrganisationCard
